import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Затеняющая подложка
 */
export function Overlay(_ref) {
  var children = _ref.children,
    zIndex = _ref.zIndex,
    outside = _ref.outside,
    onClose = _ref.onClose,
    print = _ref.print;
  var onClick = React.useCallback(function (e) {
    if (outside && e.currentTarget === e.target) {
      onClose();
    }
  }, [onClose, outside]);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['overlay'], !print && styles['no-print']),
    style: {
      zIndex: zIndex
    },
    onMouseDown: onClick,
    children: children
  });
}